import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  root: {
    display: "flex",
    position: "relative",
    flex: "auto"
  },
  namesColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: 194,
    width: 194,
    paddingTop: 24,
    marginTop: -24
  },
  name: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 14,
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 124,
    whiteSpace: "nowrap"
  },
  count: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 14
  },
  detailsLink: {
    position: "absolute",
    right: 4,
    top: 4,
    cursor: "pointer"
  },
  detailsLinkIcon: {
    "&.MuiSvgIcon-root": {
      fontSize: 12
    }
  },
  datesColumn: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    overflowX: "auto",
    alignItems: "flex-start",
    flexGrow: 1,
    paddingTop: 24,
    marginTop: -24
  },
  calendarContainer: {
    position: "relative",
    width: "100%",
    display: "flex",
    flex: "auto"
  },
  loader: {
    position: "absolute",
    height: "calc(100% + 48px)",
    marginTop: -24,
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    zIndex: 1
  },
  nextPageLoader: {
    zIndex: 1,
    position: "absolute",
    alignItems: "flex-end",
    bottom: 80
  },
  listVirtualized: {
    width: "100%"
  },
  scheduledOnly: {
    "& $__item": {
      maxWidth: "100%"
    }
  },
  __item: {}
}));
